module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiCn.89c1ab9.woff";